import type { FaireProductEntity } from "../../entity_types/product";

export const p_akwd99jl: FaireProductEntity = {
  token: "p_akwd99jl",
  type: "product",
  name: "Sweet Grapefruit - 7.2 oz Standard Candle",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/93c121ae5cb1514b1211b86f4688c4eb0f870be0c7def03c0243a0f2ec9865c5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/27cdf3f2416d70de615b7539e6ecc6b2b516f854587e6a347b20fe62186a62d1.jpeg",
    "https://cdn.faire.com/fastly/3ca8d5b3a288b27436802c4066198eeed08520bbc181c72613e5dd505dc9d2d3.jpeg",
    "https://cdn.faire.com/fastly/d23e589509df10fd4cfd0de14a22380f0973a69749467bcf1f63fa215cdfb57a.jpeg",
    "https://cdn.faire.com/fastly/b683dfaa044c6bf7149764194d7346b169dddfee50c12692e0f316e78c2f6095.jpeg",
    "https://cdn.faire.com/fastly/c759dda0d044a80b01fbeb2139253697c54d28a43f969447ee72db520a9d08ea.jpeg",
    "https://cdn.faire.com/fastly/c92432806d41e3d6f3c618531fde5312106f715a6cf03bbac99e6996e1de4217.jpeg",
  ],
  priceDollars: 11,
  description:
    "Ice cold lemonade. Dinner on the patio with your favorite people. Notes of grapefruit, yuzu, and lemon.\n\nOur best-selling 7.2 oz Standard Size. This is our most popular size and is meant for dressers, countertops, nightstands – basically everywhere. \n\nHand-poured into apothecary inspired amber jars with our signature kraft label and a brass lid. Our candles are simple - they're all made with 100% domestically grown soy wax, fine fragrance oils, and cotton-core wicks. The fragrances we use are paraben-free, phthalate-free, and never (ever) tested on animals.\n\nBurns for 40-50 hours.",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:48.965Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
